import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class InspectionService {

  private baseUrl = `${environment.apiUrl}/Surveys`;
  private baseUrl2 = `${environment.apiUrlV2}/Inspection`;
  private baseUrl4 = `${environment.apiUrlV3}/Inspection`;
  private baseUrl3 = `${environment.apiUrl}/company`;
  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  constructor(private http: HttpClient) { }

  add(body) {
    delete body.id;
    delete body.vehicleInspection.inspectionId;
    delete body.insuredInspection.inspectionId;
    //delete body.stateInspection;
    delete body.integrationProcessStatus;

    body.stateInspection = 1;
    return this.http
      .post<any>(this.baseUrl2 + '/CreatInspection', body, {
        headers: this.headers,
      })
      .toPromise();
  }

  update(body) {
    delete body.insuredInspection.inspectionId;
    delete body.vehicleInspection.inspectionId;

    return this.http
      .put<any>(`${this.baseUrl2}/${body.id}`, body, {
        headers: this.headers,
      })
      .toPromise();
  }

  deleteInspection(value) {

    return this.http
      .delete<any>(`${this.baseUrl2}/rejected/${value}`, {
        headers: this.headers,
      })
      .toPromise();
  }

  updateInspec(body) {
    delete body.insuredInspection.inspectionId;
    delete body.vehicleInspection.inspectionId;

    return this.http
      .put<any>(`${this.baseUrl2}/${body.id}`, body, {
        headers: this.headers,
      })
      .toPromise();
  }

  async getByFilter(insuranceId, filter, meta) {
    Object.keys(filter).map((x) => (filter[x] = !filter[x] ? null : filter[x]));
    return await this.http
      .post<any[]>(
        `${this.baseUrl2}/getInspectionByFilter/${insuranceId}?page=${meta.page}&size=${meta.itemsPerPage}&orderProperty=${meta.orderProperty}&order=${meta.orderBy}`,
        filter,
        { headers: this.headers }
      )
      .toPromise();
  }

  async getExportInspectionByFilter(insuranceId, filter) {
    Object.keys(filter).map((x) => (filter[x] = !filter[x] ? null : filter[x]));
    return await this.http
      .post(
        `${this.baseUrl2}/getExportInspectionByFilter/${insuranceId}`,
        filter,
        { headers: this.headers, observe: 'response', responseType: 'blob' })
      .toPromise();
  }

  async filterByBroker(brokerIdGuid, insuranceId, companyId, filter, meta) {
    Object.keys(filter).map((x) => (filter[x] = !filter[x] ? null : filter[x]));
    return await this.http
      .post<any[]>(
        `${this.baseUrl4}/getInspectionByFilterAndBroker/${brokerIdGuid}/${insuranceId}/${companyId}?page=${meta.page}&size=${meta.itemsPerPage}&orderProperty=dateRegister&order=desc`,
        filter,
        { headers: this.headers }
      )
      .toPromise();
  }

  delete(id) {
    return this.http
      .delete<any>(`${this.baseUrl}/${id}`, {
        headers: this.headers,
      })
      .toPromise();
  }

  cancelInspection(id, reasonId) {
    return this.http
      .delete<any>(`${this.baseUrl4}/${id}/${reasonId}`, {
        headers: this.headers,
        observe: 'response',
      })
      .toPromise();
  }

  cancelRequestInspection(insId) {
    return this.http
      .delete<any>(`${this.baseUrl4}/CancelRequestInspection/${insId}`, {
        headers: this.headers,
        observe: 'response',
      })
      .toPromise();
  }

  getCompanyById(id) {
    return this.http
      .get<any>(`${this.baseUrl3}/CompanyById/${id}`, {
        headers: this.headers,
      })
      .toPromise();
  }

  getById(id, token?) {
    if (token) {
      let header = new HttpHeaders({
        'Authorization': 'Bearer ' + token,
        'Accept': '*'
      })
      return this.http
        .get<any>(`${this.baseUrl2}/CompanyById/${id}`, {
          headers: header,
        })
        .toPromise();
    } else {
      return this.http
        .get<any>(`${this.baseUrl2}/CompanyById/${id}`, {
          headers: this.headers,
        })
        .toPromise();
    }

  }
  async getInactives() {
    return this.http
      .get<any>(`${this.baseUrl2}/ListInactiveCompanies`, {
        headers: this.headers,
      })
      .toPromise();
  }

  reschedulingInspection(inspectionId, surveyType) {
    let qryParam = new HttpParams().set('surveyType', surveyType);
    return this.http
      .post(`${this.baseUrl4}/reschedulingInspection/${inspectionId}?surveyType=${surveyType}`, { 
          headers: this.headers, 
          observe: 'response' 
      })
      .toPromise();
  }

  getStatusInspection(insuranceId: any) {
    return this.http
      .get<any>(`${this.baseUrl2}/ListStateInspection/${insuranceId}`, {
        headers: this.headers,
        observe: 'response',
      })
      .toPromise();
  }
  getStatusBlockedInspection(insuranceId: any) {
    return this.http
      .get<any>(`${this.baseUrl2}/ListStateInspectionBlocked/${insuranceId}`, {
        headers: this.headers,
        observe: 'response',
      })
      .toPromise();
  }

  updateAndResendLink(body: any) {
      return this.http
        .put<any>(`${this.baseUrl4}/ResendLinkUpdateInspection/${body.id}`, body, {
          headers: this.headers,
          observe: 'response',
        })
        .toPromise();
  }

  sendToken(insuranceId: any,inspectionId: any) {
    return this.http
      .post<any>(`${this.baseUrl4}/ResendLinkInspection/${insuranceId}/${inspectionId}`, {
        headers: this.headers,
        observe: 'response',
      });
  }
  
  changeProvider(changerBody) {

    return this.http
      .post(
        `${this.baseUrl2}/ChangeProvider`, changerBody, { headers: this.headers, observe: 'response' }).toPromise();
  }

  getProvider(objRequest: any) {
    return this.http
      .post<any>(`${this.baseUrl2}/GetSucursal`, objRequest, { headers: this.headers, observe: 'response' }).toPromise();
    // let mockResponse = [
    //   {
    //       name: "PLANETUN TECNOLOGIA DA INFORMACAO LTDA",
    //       station: "both",
    //       phone: "(11) 00000-0000",
    //       address: "Rua Teste, 123 - Bairro Teste, São Paulo - SP, 01234-567",
    //       openingHours: "Segunda a Sexta das 08:00 às 18:00"
    //   }
    // ];
    // return of(mockResponse);
  }
  verifyState(insuranceId: string, state: number): Promise<boolean> {
    return this.http
      .get<boolean>(`${this.baseUrl2}/VerifyState/${insuranceId}?state=${state}`, {
        headers: this.headers,
      })
      .toPromise();
  }
}



